export const CUSTOMER_STATUS = [
  'ACTIVE',
  'INACTIVE'
]

export const STATUS = ({all, active, inactive} : CustomerSummaryState) : CustomerStatusFilter[] => [
  {
    key: '',
    label: 'Semua',
    count: all
  },
  {
    key: 'ACTIVE',
    label: 'Active',
    count: active
  },
  {
    key: 'INACTIVE',
    label: 'Inactive',
    count: inactive
  }
]

export const STATUS_FILTER_COLOR_MAPPING : {[key:string]: {[key:string]:string}} =  {
  ACTIVE: {
    button: 'bg-blue-light',
    count: 'bg-opacity-10 bg-white'
  },
  INACTIVE: {
    button: 'bg-white text-grey-dark font-medium text-sm',
    count: 'bg-grey-subtle'
  }
}
